import BaseTrackingView from '../../core/baseTrackingView';
import { addToDataLayerForLinks } from '../../../home24-shared/tracking/common/helper';

export default BaseTrackingView.extend({
  events: {
    'click .js-usp-track-link': 'trackLinkClick'
  },

  trackLinkClick(clickEvent) {
    const anchorElement = clickEvent.target;

    const textContent = anchorElement.textContent;
    const innerText = anchorElement.innerText;
    const targetUrl = anchorElement.pathname;
    const labelIdentifier = anchorElement.getAttribute('data-track-identifier');
    const listIndex = Number(
      anchorElement.getAttribute('data-track-list-index')
    );
    const listLength = Number(
      anchorElement.getAttribute('data-track-list-length')
    );

    // see: http://perfectionkills.com/the-poor-misunderstood-innerText/
    const label = (textContent || innerText || '').trim();

    const gtmData = {
      event: 'headerTracking',
      eventCategory: 'link',
      eventAction: 'click',
      eventData: {
        placement: 'uspBar',
        label,
        labelIdentifier,
        targetUrl,
        listIndex,
        listLength
      }
    };

    addToDataLayerForLinks(clickEvent, gtmData);
  }
});



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/common/UspEvents.js
 **/